import { client } from "api";
import { Company } from "models/Company";

export type RestoreCompanyRequest = {
  companyId: string;
  reason?: string;
};

export type RestoreCompanyResponse = Company;

export const restoreCompany = ({ companyId, reason }: RestoreCompanyRequest) =>
  client.post<RestoreCompanyResponse>(`/company/${companyId}/restore`, { reason }).then((res) => res.data);
